import Joi from "joi"

export default Joi.object({
	firstname: Joi.string().min(1).max(30).required().messages({
		"string.base": `Le prénom doit être un texte`,
		"string.empty": `Saisissez votre prénom`,
		"string.min": `Le prénom doit avoir au moins {#limit} lettres`,
		"string.max": `Le prénom doit avoir au plus {#limit} lettres`,
		"any.required": "Saisissez votre prénom",
	}),

	lastname: Joi.string().min(1).max(30).required().messages({
		"string.base": `Le nom doit être un texte`,
		"string.empty": `Saisissez votre nom de famille`,
		"string.min": `Le nom doit avoir au moins {#limit} lettres`,
		"string.max": `Le nom doit avoir au plus {#limit} lettres`,
		"any.required": "Saisissez votre nom de famille",
	}),

	birth: Joi.date().max("now").required().messages({
		"date.base": `Saisissez votre date de naissance`,
		"date.max": `Votre date de naissance ne doit pas dépasser la date d'aujourd'hui.`,
		"any.required": "Saisissez votre date de naissance",
	}),

	email: Joi.string()
		.email({ minDomainSegments: 2, tlds: { allow: ["com", "fr", "io"] } })
		.messages({
			"string.base": `L'email n'a pas le bon format (un texte)`,
			"string.empty": `Saisissez votre email`,
			"string.email": `L'email n'a pas le bon format (.com ou .fr)`,
			"any.required": "Saisissez votre email",
		}),

	phone: Joi.string()
		.pattern(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/i)
		.required()
		.messages({
			"string.base": `Le numéro de telephone n'a pas le bon format`,
			"string.empty": `Saisissez votre numéro de téléphone`,
			"string.pattern.base": `Seuls les numéro français sont acceptés`,
			"any.required": "Saisissez votre numéro de téléphone",
		}),

	address: Joi.any(),
	manual_billing_address: Joi.string().allow(""),
	manual_billing_postal_code: Joi.string().allow(""),
	manual_billing_city: Joi.string().allow(""),
	manual_billing_additional_address_line: Joi.string().allow(""),
	social_security: Joi.string()
		.pattern(
			/^[1-478][0-9]{2}(0[1-9]|1[0-2]|62|63)(2[ABab]|[0-9]{2})(00[1-9]|0[1-9][0-9]|[1-8][0-9]{2}|9[0-8][0-9]|990)(00[1-9]|0[1-9][0-9]|[1-9][0-9]{2})(0[1-9]|[1-8][0-9]|9[0-7])$/i,
		)
		.required()
		.messages({
			"string.base": `Le numéro de sécurité social n'a pas le bon format`,
			"string.empty": `Saisissez votre numéro de sécurité social`,
			"string.pattern.base": `Le numéro de sécurité social n'a pas le bon format`,
			"any.required": "Saisissez votre numéro de sécurité social",
		}),

	no_amc_coverage: Joi.boolean().allow(null, ""),

	organism_amc: Joi.when("no_amc_coverage", {
		is: true,
		then: Joi.any().allow(null, ""),
		otherwise: Joi.any().allow(null, ""),
	}).messages({
		"any.required": "Sélectionnez un organisme AMC",
	}),

	/* mutual: Joi.string().max(15).required().messages({
		"string.base": `Le nom de mutuelle doit être un texte`,
		"string.empty": `Saisissez le nom de votre mutuelle`,
		"string.max": `Le nom de votre mutuelle doit avoir au plus {#limit} caractères`,
		"any.required": "Saisissez le nom de votre mutuelle",
	}), */

	prescriber: Joi.any() /* .invalid(null, {}).required().messages({
		"any.invalid": `Saisissez le nom de votre prescripteur`,
		"any.required": `Saisissez le nom de votre prescripteur`,
	}) */,
	article: Joi.any(),
	// size: Joi.string().allow(""),
	prescription: Joi.any(),
	prescription_bis: Joi.any(),
	prescription_ter: Joi.any(),
	mutual_photo: Joi.any(),

	accept: Joi.string().valid(true).required().messages({
		"any.only": ``, // error in front outside input
		"any.required": ``, // error in front outside input
	}),
	toggle_manual_billing_address: Joi.boolean(),
	toggle_prescription_bis: Joi.boolean(),
	toggle_prescription_ter: Joi.boolean(),
})
